import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=ce603932&scoped=true"
import script from "./PanelGroup.vue?vue&type=script&lang=js"
export * from "./PanelGroup.vue?vue&type=script&lang=js"
import style0 from "./PanelGroup.vue?vue&type=style&index=0&id=ce603932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce603932",
  null
  
)

export default component.exports